export default "__VITE_ASSET__mEKI6DWM__"